import { useParams } from 'react-router-dom';
import CreateDocument from './CreateDocument';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { getKnowledgeDetail } from 'slices/thunk';

const UpdateKnowledge = () => {
  const { knowledgeId } = useParams<{ knowledgeId: string }>();
  const dispatch = useDispatch<any>();

  useEffect(() => {
    if (knowledgeId) {
      dispatch(getKnowledgeDetail(knowledgeId));
    }
  }, [knowledgeId, dispatch]);

  return <CreateDocument defaultValues={{ id: knowledgeId }} />
}

export default UpdateKnowledge;
